import Api from "@/services/api";
import {
ADD_ALERT
} from "@/store/_actiontypes";
import PersonalizerApi from "@/services/personalizer_api";
import {
    GET_QUESTIONNAIRE_LOG,
} from "@/store/_actiontypes";
import {
} from "@/store/_mutationtypes";

import { updateLoaderTo } from "./account";

const state = {};

const actions = {
    [GET_QUESTIONNAIRE_LOG]({ commit, dispatch }, { project_id, params }) {
        updateLoaderTo(true);
       const params_string = new URLSearchParams(params).toString();
        return new Promise((resolve, reject) => {
            PersonalizerApi.get(`questionnaires/logs?${params_string}`,
                {
                    headers: {
                        "project-id": project_id,
                    },
                }
            ).then(
                    (response) => {
                        updateLoaderTo(false);
                        resolve(response);
                    },
                    (error) => {
                        updateLoaderTo(false);
                        reject(error);
                        dispatch(
                            `alert/${ADD_ALERT}`,
                            { message: error.response.data.detail.response, color: "error" },
                            { root: true }
                          );
                    }
                );
        });
    },
};

const mutations = {};

export const questionnaire = {
    namespaced: true,
    state,
    actions,
    mutations,
};
